document.addEventListener('DOMContentLoaded', function() {
  // Get all navigation items
  const navItems = document.querySelectorAll('.membership-profile-events-nav__item');

  // Add click event listener to each navigation item
  if (navItems) {
    navItems.forEach(item => {
      item.addEventListener('click', function() {
        // Get the target group from the data-nav-target attribute
        const targetGroup = this.getAttribute('data-nav-target');

        // Remove is-active class from all nav items
        navItems.forEach(navItem => {
          navItem.classList.remove('is-active');
        });

        // Add is-active class to the clicked nav item
        this.classList.add('is-active');

        // Get all content groups
        const contentGroups = document.querySelectorAll('.events-detail-card-group');

        // Remove is-visible class from all content groups
        contentGroups.forEach(group => {
          group.classList.remove('is-visible');
        });

        // Add is-visible class to the target content group
        const targetContentGroup = document.querySelector(`.events-detail-card-group[data-group="${targetGroup}"]`);
        if (targetContentGroup) {
          targetContentGroup.classList.add('is-visible');
        }
      });
    });
  }
});
